<template>
  <div v-if="dialogVisible">
    <el-dialog
      :title="$t('lang.usercontrol.USER_UPDATE')"
      :visible.sync="dialogVisible"
      width="45%"
      center>
      <img v-if="usermessagelist.user_icon" :src="usermessagelist.user_icon" class="useravatar">
      <img v-if="!usermessagelist.user_icon" src="../../../../assets/useravatar.png" class="useravatar">
      <div class="concen">
        <el-form label-width="150px" label-position="right">
          <el-form-item :label="`${$t('lang.usercontrol.UserGroup')}：`">
            <span class="usertext">{{usermessagelist.username}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.belonging')}：`">
            <span class="usertext" v-if="usermessagelist.customer">{{usermessagelist.customer.c_name}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.bituser')}：`">
            <span 
              class="usertext" 
              v-if="usermessagelist.user_iscustomer==0" >
              {{$t('lang.usercontrol.usertype1')}}
            </span>
            <span 
              class="usertext" 
              v-if="usermessagelist.user_iscustomer == 1 && usermessagelist.user_ctid != 0">
              {{$t('lang.usercontrol.usertype2')}}
            </span>
            <span
              class="usertext"
              v-if="usermessagelist.user_iscustomer == 1 && usermessagelist.user_ctid == 0">
              {{$t('lang.usercontrol.usertype3')}}
            </span>
            <span
              class="usertext"
              v-if="usermessagelist.user_iscustomer == 2 && usermessagelist.user_ctid == 0">
              {{$t('lang.usercontrol.usertype4')}}
            </span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.FILE_REAL_H')}：`">
            <span class="usertext">{{usermessagelist.realname}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.email')}：`">
            <span class="usertext">{{usermessagelist.user_email}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.phone')}：`">
            <span class="usertext">{{usermessagelist.user_tel}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.socialize')}：`">
            <span class="usertext">{{usermessagelist.user_qq}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.address')}：`">
            <span class="usertext">{{usermessagelist.user_addr}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.user_admin')}：`">
            <span class="usertext" v-if="usermessagelist.role">{{usermessagelist.role.roleName}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.recently')}：`">
            <span class="usertext">{{usermessagelist.user_update}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.usercontrol.recently')}：`">
            <span class="usertext">{{usermessagelist.user_update}}</span>
          </el-form-item>
          <el-form-item :label="`${$t('lang.ConfigSetting.Language')}：`">
            <span class="usertext">{{usermessagelist.user_language}}</span>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      usermessagelist: {},
    }
  },
  methods: {
    show(item) {
      this.usermessagelist = item
      this.dialogVisible = true
    }
  }
}
</script>
<style scoped>
.useravatar {
  width: 1.5rem;
  height: 1.5rem;
  margin: 0.2rem auto;
  display: block;
  border-radius: 50%;
}
.usertext {
  font-size: 0.3rem;
}
.concen{
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.el-form-item{
  margin-bottom: 0;
}
</style>